﻿import { FieldNames } from "@/enums";

export const getUserIdForProjectLeaderRegion = (
  regionalProjectLeaders,
  flatForms
) => {
  if (!regionalProjectLeaders || !flatForms) return;

  let userId;

  Object.keys(regionalProjectLeaders).forEach((regionId) => {
    const workingUserId = regionalProjectLeaders[regionId];

    if (!workingUserId) return;

    const regions = flatForms.find(
      ({ property }) => property.label.fallback === FieldNames.Region
    )?.values;

    if (!regions?.length) return;

    const workingRegion = regions.find(
      ({ id, label: { fallback } }) => id === regionId && fallback === "USA"
    );

    if (!workingRegion) return;

    userId = workingUserId;
  });

  return userId;
};
